import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AnalyticsService } from './services/analytics.service';
import { ConsentService } from './services/consent.service';
import { ConsentUiService } from './services/consent-ui.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  showConsentModal = false;
  showConsentCustomization = false;
  consentAnalytics = false;
  readonly appLinks = [
    { label: 'Noisy Radio', href: 'https://noisyradio.wahl.website' },
    { label: 'Noisy Podcaster', href: 'https://noisypodcaster.wahl.website' },
    { label: 'Noisy Sleeper', href: 'https://noisysleeper.wahl.website' },
  ];

  private subscriptions = new Subscription();

  private consentService = inject(ConsentService);
  private consentUi = inject(ConsentUiService);
  private analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    if (!this.consentService.hasStoredConsent()) {
      this.consentService.acceptAll();
    }
    this.syncConsentState();
    this.analyticsService.start();

    this.subscriptions.add(
      this.consentUi.open$.subscribe(() => {
        this.openConsentPreferences(true);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openConsentPreferences(forceCustomize = false): void {
    this.syncConsentState();
    this.showConsentCustomization = forceCustomize || this.consentService.hasStoredConsent();
    this.showConsentModal = true;
  }

  closeConsentModal(): void {
    this.showConsentModal = false;
    this.showConsentCustomization = false;
  }

  acceptAllConsent(): void {
    this.consentService.acceptAll();
    this.closeConsentModal();
  }

  rejectAllConsent(): void {
    this.consentService.rejectAll();
    this.closeConsentModal();
  }

  saveCustomConsent(): void {
    this.consentService.saveCustom(this.consentAnalytics);
    this.closeConsentModal();
  }

  private syncConsentState(): void {
    const state = this.consentService.getState();
    this.consentAnalytics = state?.analytics ?? false;
  }
}
